import { createContext } from 'react';
import { IItemForGetShortInfo, TLanguageIDs, IMenuTranslation, IDefaultLanguage, ICreateModifierGroupsV2 } from 'types';

export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';

export interface ICreateModifierGroupsState {
	fetchedCustomers: IItemForGetShortInfo[];
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDsSelectedRestaurant: string[];
	nameOfModifierGroup: string;
	externalId: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	translations: IMenuTranslation[];
	dataForSubmit: Nullable<ICreateModifierGroupsV2>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const createModifierGroupsInitialState: ICreateModifierGroupsState = {
	fetchedCustomers: [],
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	IDsSelectedRestaurant: [],
	nameOfModifierGroup: '',
	externalId: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateModifierGroupsContext extends ICreateModifierGroupsState {
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setIDsRestaurant(value: string[]): void;
	changeNameOfModifierGroup(value: string): void;
	changeExternalId(value: string): void;
	generateUniqueExternalId(): void;
	setFetchedTranslations(value: TLanguageIDs[], defaultCustomerLanguage: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(data: Nullable<ICreateModifierGroupsV2>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	resetFields(): void;
}

export const CreateModifierGroupsContext = createContext<ICreateModifierGroupsContext>({
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	changeNameOfModifierGroup: () => undefined,
	changeExternalId: () => undefined,
	generateUniqueExternalId: () => undefined,
	setFetchedTranslations: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createModifierGroupsInitialState,
});
